import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getSelfServiceData, selectEmployeeNo } from '@/Redux/Ducks/homeSlice';
import BaseMethods from 'AlignBaseUI/BaseMethods';
import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

// Custom Styles for the Select Component
const customStyles = {
  container: (base: any) => ({
    ...base,
    width: '250px',
  }),
  control: (base: any) => ({
    ...base,
    border: '1px solid #cbcbcb',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #0ac3da',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    fontSize: '11px',
    color: '#000',
    fontWeight: 'bold',
  }),
  placeholder: (base: any) => ({
    ...base,
    fontSize: '9px',
    color: '#575757ab',
    fontWeight: 'normal',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: state.isSelected ? '#0ac3da' : 'inherit',
    '&:hover': {
      backgroundColor: state.isSelected ? '#0ac3da' : '#e7f9fb',
    },
  }),
};

// Custom Components for the Select Component
const { ValueContainer, Placeholder, SingleValue } = components;

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <ValueContainer {...props}>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const CustomSingleValue = (props: any) => {
  const { data } = props;

  return (
    <SingleValue {...props}>
      <div className="employee-selector-value">
        <img src={BaseMethods.getUserPhoto(data.employeeimage)} alt="" />
        <div className="text">
          <h6>{data.employeestxt}</h6>
          <span>{data.positionstxt}</span>
        </div>
      </div>
    </SingleValue>
  );
};

const CustomOption = (props: any) => {
  const { data, innerRef, innerProps, isSelected } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`employee-selector-value option ${isSelected ? 'selected' : ''}`}
    >
      <img src={BaseMethods.getUserPhoto(data.employeeimage)} alt="" />
      <div className="text">
        <h6>{data.employeestxt}</h6>
        <span>{data.positionstxt}</span>
      </div>
    </div>
  );
};

const EmployeeSelector = () => {
  const dispatch = useAppDispatch();
  const [options, setOptions] = useState<any>([]);
  const { employees, selectedEmployee } = useAppSelector((state) => ({
    employees: state.Home.employees,
    selectedEmployee: state.Home.selectedEmployeeNo
  }));

  useEffect(() => {
    setOptions(
      employees.map((x) => ({
        value: x.employeeno,
        label: `${x.employeestxt} (${x.employeeno})`,
        employeestxt: x.employeestxt,
        positionstxt: x.positionstxt,
        employeeimage: x.employeeimage,
      }))
    );
  }, [employees]);

  const changeEmployeeData = (option: any) => {
    dispatch(selectEmployeeNo(option.value));
    dispatch(getSelfServiceData());
  };

  return options.length >= 1 ? (
    <div>
      {selectedEmployee ? (
        <Select
          components={{
            ValueContainer: CustomValueContainer,
            SingleValue: CustomSingleValue,
            Option: CustomOption,
          }}
          options={options}
          value={options.find((x: any) => x.value === selectedEmployee)}
          onChange={changeEmployeeData}
          placeholder="Select Employee"
          styles={customStyles}
          className="employee-selector"
        />
      ) : null}
    </div>
  ) : null;
};

export default EmployeeSelector;
